import { AuthContext } from '../../contexts/auth';
import { useState, useEffect, useContext } from 'react';
import { listarEquipamentos } from '../../services/apigateway';

import Cabecalho from '../../components/Cabecalho/cabecalho';
import Titulo from '../../components/Titulo/titulo';
import Rodape from '../../components/Rodape/rodape';
import Menu from '../../components/Menu/menu';

import ProcessandoModal from '../../components/Processamento/processamento';

import Globais from '../../components/Globais/Globais';
import Tabela from '../../components/Table/tabela';
import Comandos from '../../components/Comandos/comandos';
import Paginate from '../../components/Paginate/paginate';

export default function Equipamentos(){
  const { clienteId, ligaMenu } = useContext(AuthContext);
  const [equipamentos, setEquipamentos] = useState([]);
  const [equipamentoFiltrado, setEquipamentoFiltrado] = useState([]);
  const [equipamentoPaginado, setEquipamentoPaginado] = useState([]);

  const [loading, setLoading] = useState(true);

  const [coluna, setColuna] = useState();
  const [ordem, setOrdem] = useState('asc');

  const [currentPage, setCurrentPage] = useState(0);
  const [qtdPaginas, setQtdPaginas] = useState(0);
  const [qtdLinhas, setQtdLinhas] = useState(Globais.qtd_linhas); 

  const elementos = [
    {coluna: 'cod_equipamento', cabecalho: 'Código', alinhamento: 'tdtabela'},
    {coluna: 'mod_equipamento', cabecalho: 'Modelo', alinhamento: 'tdtabelaleft'},
    {coluna: 'mod_equipamento', cabecalho: 'Tag', alinhamento: 'tdtabelaleft'},
    {coluna: 'sit_equipamento', cabecalho: 'Situação', alinhamento: 'tdtabela'}, 
    {coluna: 'ação', cabecalho: 'Ação', alinhamento: 'tdtabela'}
  ];

  useEffect(() => {
      loadEquipamentos();
      return() => {}
  }, []);

  async function loadEquipamentos(){
    try {
      if (!clienteId) {
        setLoading(false);
        return (<></>);
      }

      const result = await listarEquipamentos(clienteId);

      setEquipamentos(result);

      let dados = filterEquipamentos(result, 'Modelo', '');
      setEquipamentoFiltrado(dados);
   
      let qtdpag = Math.ceil(dados.length / qtdLinhas)
      setQtdPaginas(qtdpag);
  
      let datas = paginarEquipamentos(dados, 0, qtdLinhas);
      setEquipamentoPaginado(datas);
      setLoading(false);
      setQtdPaginas(qtdpag);
  
    } catch(err) {
      console.log(err);
    }

    setLoading(false);
  }

  function filterEquipamentos(dados, campo, texto) {
    let data = [];

    if (campo === 'Modelo') {
      dados && dados.filter(item => {return item.mod_equipamento.toLowerCase().includes(texto)}).map(dado => {
        data.push(dado)
      });

    } else {
      dados && dados.filter(item => {return item.tag_equipamento.toLowerCase().includes(texto)}).map(dado => {
        data.push(dado)
      });
    }

    return data; 
  }  
 
  function paginarEquipamentos(dados, offSet, qtdLinhas) {
    const startIndex = offSet;
    const endIndex = offSet + Number(qtdLinhas);

    let data = dados;
    return data.slice(startIndex, endIndex)
  }

  function handleSearch(campo, texto) {
    let dados = filterEquipamentos(equipamentos, campo, texto);
    setEquipamentoFiltrado(dados);

    let qtdpag = Math.ceil(dados.length / qtdLinhas)
    setQtdPaginas(qtdpag); 

    let data = paginarEquipamentos(dados, 0, qtdLinhas)
    setEquipamentoPaginado(data);  
    setCurrentPage(0);
    setColuna();
  }

  function handlePageClick({ selected: selectedPage }) { 
    let posicao = (selectedPage) * qtdLinhas;
    setCurrentPage(selectedPage); 

    let data = paginarEquipamentos(equipamentoFiltrado, posicao, qtdLinhas);
    setEquipamentoPaginado(data); 
  } 

  function handleQtdLinhas(valor) {
    if (Number(valor) === 0) {
      valor = equipamentoFiltrado.length;
    }

    setQtdLinhas(valor);

    let qtdpag = Math.ceil(equipamentoFiltrado.length / valor)
    setQtdPaginas(qtdpag);

    let data = paginarEquipamentos(equipamentoFiltrado, 0, valor);
    setEquipamentoPaginado(data); 

    setCurrentPage(0); 
  } 
    
  function handleSort(coluna) {
    // console.log('Coluna: ', coluna);
    // console.log('Ordem: ', ordem );
    let order = ordem;

    if (order === 'asc') {
      order = 'desc';
    } else {
      order = 'asc';
    }

    setColuna(coluna);
    setOrdem(order);

    const dataCopy = [...equipamentoFiltrado];

    dataCopy.sort((dataA, dataB) => {
      if (order === 'desc') {
        return dataA[coluna] > dataB[coluna] ? 1 : -1

      } else {
        return dataB[coluna] > dataA[coluna] ? 1 : -1
      }
    }); 

    setEquipamentoFiltrado(dataCopy); 

    let data = paginarEquipamentos(dataCopy, 0, qtdLinhas);
    setEquipamentoPaginado(data); 
    setCurrentPage(0); 
  }

  if (loading){
    return(
      <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
        <Cabecalho />
      
      <main>
        <Titulo tela={'Cadastro de Equipamentos'} />

        <section
          className="md:grid grid-cols-1"
          style={{
            gridTemplateColumns: ligaMenu
              ? 'minmax(175px, 20%) minmax(60%, 80%)'
              : 'minmax(48px, 5%) minmax(70%, 95%)',
          }}
        >
          <Menu />
          <ProcessandoModal open={loading} message="Aguarde, buscando Equipamentos..." />
        </section>
      </main>
    </div>
    )
  }
 
  return (
    <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
      <Cabecalho />
      
      <main>
        <Titulo 
          tela={'Cadastro de Equipamentos'} 
          destination='/equipamentos/inclusao/'
          permissao='EQUIPAMENTO_INCLUIR'
        />

        <section
          className="md:grid grid-cols-1"
          style={{
            gridTemplateColumns: ligaMenu
              ? 'minmax(175px, 20%) minmax(60%, 80%)'
              : 'minmax(48px, 5%) minmax(70%, 95%)',
          }}
        >
          <Menu />
          <div>  
            <div className="flex flex items-center gap-4 p-2">
              <label>Modelo:</label>
              <div className="single-input">
                <input 
                  type="text" 
                  id='modelo' 
                  name='modelo' 
                  placeholder='Modelo do Equipamento' 
                  className='p-2 border border-gray-300 rounded-md' 
                  autoComplete='modelo' 
                  onChange={e => handleSearch('Modelo', e.target.value)}
                />
              </div>
              <label>Tag:</label>
              <div className="single-input">
                <input 
                  type="text" 
                  id='tag' 
                  name='tag' 
                  placeholder='Tag do Equipamento' 
                  className='p-2 border border-gray-300 rounded-md' 
                  autoComplete='numero' 
                  onChange={e => handleSearch('Tag', e.target.value)}
                />
              </div>
            </div>
            <Tabela
              entidade='Equipamentos' 
              dados={equipamentoPaginado}
              elementos={elementos}
              handleSort={handleSort}
              sortedId={coluna}
              ordem={ordem}
              urlBase='/equipamentos'
            />

            {qtdPaginas > 1 ? (
              <div className='pagination-container'>
                <Comandos 
                  linhas = {qtdLinhas}
                  handleQtdLinhas = {handleQtdLinhas}
                  qtdRegistros = {equipamentoFiltrado.length} 
                />
                
                <Paginate
                  qtdPaginas={qtdPaginas}
                  handlePageClick={handlePageClick}
                  currentPage={currentPage}
                />

              </div>
            ) : (
              <div className='pagination-container'>
                <Comandos 
                  linhas = {qtdLinhas}
                  handleQtdLinhas = {handleQtdLinhas}
                  qtdRegistros = {equipamentoFiltrado.length} 
                />
              </div>
            )}
          </div>
        </section>
      </main>

      <Rodape versao={Globais.versao}/>
    </div>
    );
  }
  